<template>
  <div>
    <CardedSectionHeader id="policy_introduction" label="1. Introduction"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false">
            <p class="font-weight-medium text--darken-1">
                <b>These Website Standard Terms And Conditions</b> (these “Terms” or these “Website Standard Terms And Conditions”) contained herein on this webpage, shall govern your use of this website, including all pages within this website (collectively referred to herein below as this “Website”). These Terms apply in full force and effect to your use of this Website and by using this Website, you expressly accept all terms and conditions contained herein in full. You must not use this Website, if you have any objection to any of these Website Standard Terms And Conditions.
                This Website is not for use by any minors (defined as those who are not at least 18 years of age), and you must not use this Website if you a minor.
            </p>
        </PlainDisplay>
    </CardedDisplay>
    <CardedSectionHeader  label="2. Intellectual Property Rights"></CardedSectionHeader>
    <CardedDisplay >
        <PlainDisplay :show_icon="false" id="policy_iprights">
            <p class="font-weight-medium text--darken-1">
                <b>Other than content you own</b>, which you may have opted to include on this Website, under these Terms, Busyug and/or its licensors own all rights to the intellectual property and material contained in this Website, and all such rights are reserved. You are granted a limited license only, subject to the restrictions provided in these Terms, for purposes of viewing the material contained on this Website.
            </p>
        </PlainDisplay>
    </CardedDisplay>
    <CardedSectionHeader label="3. Restrictions"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false" >
            <p class="font-weight-medium text--darken-1">
                <b>You are expressly and emphatically restricted from all of the following:</b>
                <ul>
                    <li>1.	publishing any Website material in any media;</li>
                    <li>2.	selling, sublicensing and/or otherwise commercializing any Website material;</li>
                    <li>3.	publicly performing and/or showing any Website material;</li>
                    <li>4.	using this Website in any way that is, or may be, damaging to this Website;</li>
                    <li>5.	using this Website in any way that impacts user access to this Website;</li>
                    <li>6.	using this Website contrary to applicable laws and regulations, or in a way that causes, or may cause, harm to the Website, or to any person or business entity;</li>
                    <li>7.	engaging in any data mining, data harvesting, data extracting or any other similar activity in relation to this Website, or while using this Website;</li>
                    <li>8.	using this Website to engage in any advertising or marketing;</li>
                </ul>
                Certain areas of this Website are restricted from access by you and Busyug may further restrict access by you to any areas of this Website, at any time, in its sole and absolute discretion. Any user ID and password you may have for this Website are confidential and you must maintain confidentiality of such information.
            </p>
        </PlainDisplay>
    </CardedDisplay>
    <CardedSectionHeader label="4. Your Content"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false" id="policy_your_content">
            <p class="font-weight-medium text--darken-1" id="policy_your_content">
               <b>In these Website Standard Terms And Conditions</b>, “Your Content” shall mean any audio, video, text, images or other material you choose to display on this Website. With respect to Your Content, by displaying it, you grant Busyug a non-exclusive, worldwide, irrevocable, royalty-free, sublicensable license to use, reproduce, adapt, publish, translate and distribute it in any and all media.
               Your Content must be your own and must not be infringing on any third party’s rights. BUsyug reserves the right to remove any of Your Content from this Website at any time, and for any reason, without notice.
            </p>
        </PlainDisplay>
    </CardedDisplay>
    <CardedSectionHeader label="5. No warranties"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false">
            <p class="font-weight-medium text--darken-1">
                <b>This Website is provided “as is,”</b> with all faults, and Busyug makes no express or implied representations or warranties, of any kind related to this Website or the materials contained on this Website. Additionally, nothing contained on this Website shall be construed as providing consult or advice to you.
            </p>
        </PlainDisplay>
    </CardedDisplay>
    <CardedSectionHeader label="6. Limitation of liability"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false">
            <p class="font-weight-medium text--darken-1">
                <b>In no event shall Busyug</b>, nor any of its officers, directors and employees, be liable to you for anything arising out of or in any way connected with your use of this Website, whether such liability is under contract, tort or otherwise, and Busyug, including its officers, directors and employees shall not be liable for any indirect, consequential or special liability arising out of or in any way related to your use of this Website.
            </p>
        </PlainDisplay>
    </CardedDisplay>
        <CardedSectionHeader label="7. Indemnification"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false" id="policy_indemnification">
            <p class="font-weight-medium text--darken-1">
                <b>You hereby indemnify to the fullest extent</b> Busyug from and against any and all liabilities, costs, demands, causes of action, damages and expenses (including reasonable attorney’s fees) arising out of or in any way related to your breach of any of the provisions of these Terms.
            </p>
        </PlainDisplay>
    </CardedDisplay>
        <CardedSectionHeader label="8. Severability"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false">
            <p class="font-weight-medium text--darken-1">
                <b>If any provision of these Terms is found to be unenforceable</b> or invalid under any applicable law, such unenforceability or invalidity shall not render these Terms unenforceable or invalid as a whole, and such provisions shall be deleted without affecting the remaining provisions herein.
            </p>
        </PlainDisplay>
    </CardedDisplay>
        <CardedSectionHeader label="9. Variation of Terms"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false">
            <p class="font-weight-medium text--darken-1">
                <b>Busyug is permitted to revise these Terms</b> at any time as it sees fit, and by using this Website you are expected to review such Terms on a regular basis to ensure you understand all terms and conditions governing use of this Website.
            </p>
        </PlainDisplay>
    </CardedDisplay>
        <CardedSectionHeader label="10. Assignment"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false" id="policy_assignment">
            <p class="font-weight-medium text--darken-1">
                <b>Busyug shall be permitted to assign</b>, transfer, and subcontract its rights and/or obligations under these Terms without any notification or consent required. However, .you shall not be permitted to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.
            </p>
        </PlainDisplay>
    </CardedDisplay>
        <CardedSectionHeader label="11. Entire Agreement"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false">
            <p class="font-weight-medium text--darken-1">
                <b>These Terms, including any legal notices and disclaimers</b> contained on this Website, constitute the entire agreement between Busyug and you in relation to your use of this Website, and supersede all prior agreements and understandings with respect to the same.
            </p>
        </PlainDisplay>
    </CardedDisplay>
        <CardedSectionHeader label="12. Governing Law & Jurisdiction"></CardedSectionHeader>
    <CardedDisplay>
        <PlainDisplay :show_icon="false">
            <p class="font-weight-medium text--darken-1">
                <b>These Terms will be governed by and construed</b> in accordance with the laws of the State of Botswana, and you submit to the non-exclusive jurisdiction of the state and federal courts located in Botswana for the resolution of any disputes.
            </p>
        </PlainDisplay>
    </CardedDisplay>
        
  </div>
</template>


<script>
import CardedSectionHeader from "./CardedSectionHeader";
import CardedDisplay from "./CardedDisplay";
import PlainDisplay from "./PlainDisplay";
export default {
  name: "PolicyText",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
  },
  
};
</script>
